import * as XLSX from "xlsx";

export type TableExportFormat = "csv" | "excel";

export const exportTableData = <T extends object>(
  rows: T[],
  format: TableExportFormat,
  fileName: string,
  sheetName: string
): void => {
  if (rows.length === 0) return;

  const columns = Object.keys(rows[0] ?? {});
  const escapeCell = (value: unknown): string => {
    const text = value == null ? "" : String(value).replace(/\r?\n/g, " ");
    return `"${text.replace(/"/g, '""')}"`;
  };

  let blob: Blob;
  let extension: string;

  if (format === "csv") {
    const csv = [
      columns.join(","),
      ...rows.map((row) =>
        columns.map((column) => escapeCell((row as Record<string, unknown>)[column])).join(",")
      ),
    ].join("\n");
    blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    extension = "csv";
  } else {
    const workbook = XLSX.utils.book_new();
    const sheetData = rows.map((row) => {
      const values: Record<string, unknown> = {};
      columns.forEach((column) => {
        values[column] = (row as Record<string, unknown>)[column] ?? "";
      });
      return values;
    });
    const worksheet = XLSX.utils.json_to_sheet(sheetData, { header: columns });
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    const workbookBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    blob = new Blob([workbookBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    extension = "xlsx";
  }

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileName}.${extension}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};